import React from 'react';
import { times } from 'lodash';
import Table from '../table';
import IndexTableHeader from './table/header';
import TableLoadingCell from './TableLoadingCell';

const TableLoadingRow = ({ selectable, tableHeaders }) => (
  <Table.Row>
    {selectable && <TableLoadingCell size="xs" width="70" />}
    {tableHeaders.map(cell => (
      <TableLoadingCell
        key={cell.name}
        roleTag={cell.loadingPlaceholder.roleTag}
        size={cell.size}
        width={cell.loadingPlaceholder.width}
      />
    ))}
  </Table.Row>
);

const TableLoadingState = ({ totalRows, tableHeaders, selectable }) => (
  <Table className="Index-table" alternate noBorderTop roundedBottom>
    <IndexTableHeader
      selectable={selectable}
      tableHeaders={tableHeaders}
      useHideClass
    />
    <div className="Table-body">
      {times(totalRows, i => (
        <TableLoadingRow key={i} {...{ tableHeaders, selectable }} />
      ))}
    </div>
  </Table>
);

TableLoadingState.defaultProps = {
  selectable: true,
  totalRows: 3,
};

export default TableLoadingState;
